import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function connect (filialId) {
    return axios.patch(`${CRM_API_URL}/filials/${filialId}/connect`).then(response => response.data)
}

function connectToCallCenter (filialId) {
  return axios.patch(`${CRM_API_URL}/filials/${filialId}/callcenter/connect`).then(response => response.data)
}

function disconnectFromCallCenter (filialId) {
  return axios.patch(`${CRM_API_URL}/filials/${filialId}/callcenter/disconnect`).then(response => response.data)
}

function updateSettings (filialId, data) {
  return axios.put(`${CRM_API_URL}/filials/settings`, { data }, { params: { cur_filial_id: filialId } })
    .then(response => response.data)
}

export default { connect, connectToCallCenter, disconnectFromCallCenter, updateSettings }
